import { EventsList } from '../../../components/Events/EventsList'

export const EventsAllPage = () => <EventsList scope="all" />
